import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-white" data-id="element-13">
      <div className="container mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-16 items-center" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-15">
          <div className="aspect-[3/4] w-full max-w-md mx-auto relative" data-id="element-16">
            <div className="w-full h-full bg-[#F9F9F9] border border-gray-100 rounded-t-full flex items-center justify-center" data-id="element-17">
              <div className="text-center" data-id="element-18">
                <p className="text-xs text-gray-400 font-light tracking-widest uppercase" data-id="element-19">
                  Портрет майстра
                </p>
              </div>
            </div>
            <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-white rounded-full flex items-center justify-center border border-gray-100 shadow-sm" data-id="element-20">
              <div className="text-center" data-id="element-21">
                <span className="block font-heading text-3xl text-accent" data-id="element-22">
                  12+
                </span>
                <span className="text-[10px] uppercase tracking-widest text-gray-500" data-id="element-23">
                  років
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-24">
          <h2 className="font-heading text-4xl md:text-5xl text-dark mb-6" data-id="element-25">
            Про мене
          </h2>
          <div className="w-12 h-px bg-accent mb-8" data-id="element-26"></div>

          <div className="space-y-6 text-gray-600 font-light leading-relaxed" data-id="element-27">
            <p data-id="element-28">
              Привіт! Я Валентина — майстер-перукар та колорист з понад
              12-річним досвідом. Моя місія — не просто змінити вашу зачіску, а
              підкреслити вашу індивідуальність та природну красу.
            </p>
            <p data-id="element-29">
              Я постійно навчаюсь, відвідую міжнародні майстер-класи та слідкую
              за останніми трендами у світі б'юті-індустрії. Для мене важливо
              використовувати лише якісні та безпечні матеріали, щоб ваше
              волосся завжди виглядало здоровим та доглянутим.
            </p>
            <p className="italic text-dark font-medium border-l-2 border-accent pl-4 py-2" data-id="element-30">
              "Краса волосся починається з його здоров'я. Моя мета — навчити вас
              любити своє волосся та правильно за ним доглядати."
            </p>
          </div>

          <div className="mt-10" data-id="element-31">
            <div className="h-12 w-32 border-b border-gray-300 flex items-end pb-2" data-id="element-32">
              <span className="text-[10px] text-gray-400 uppercase tracking-widest" data-id="element-33">
                Підпис
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}